import React, { useContext, useEffect, useState } from 'react';
import { ThemeContext } from '../../context/ThemeContext';

import useSecureStorage from '../../hooks/useSecureStorage';
import useQssMnemonic from '../../hooks/useQssMnemonic';

import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { checkHeaderText, checkMnemonic, RootState } from '../../store';

import * as bip39 from 'bip39'

import WebApp from '@twa-dev/sdk'

interface QssData {
    name: string
    mnemonic: string
    network: string
}

const QssLoadDataList : React.FC = () => {
    const { theme } = useContext(ThemeContext)
    let navigate = useNavigate();
    let dispatch = useDispatch();
    const { t } = useTranslation();
    const { setIsUseQss, setIsSavedQssMnemonic, setLocalMnemonicHash, getBlockChain } = useSecureStorage()
    const { getQssMnemonic } = useQssMnemonic()
    const [qssMnemonicList, setQssMnemonicList] = useState<QssData[]>([]);
    
    const qssPassword = useSelector((state: RootState) => state.qssPassword.value);

    let qSSIndex = -1;

    useEffect(() => {
        dispatch(checkHeaderText({ "link": "QssLoadDataList", "title": '' }))
    }, [])

    useEffect(() => {
        const initializeAssets = async () => {
            try {
                // qss 저장된 데이터 로드
                const selNetwork = await getBlockChain()
                const qssMnemonic = await getQssMnemonic(qssPassword, selNetwork)
				// console.log(`QssLoadDataList qss 저장된 니모닉 리스트`, qssMnemonic)

                if(null == qssMnemonic || null == qssMnemonic.value) {
                    // qss 저장된 데이터 없음
                    return
                }

                // 임시저장 qss 비밀번호 리셋
                // dispatch(checkQssPassword(''))

				if(true === qssMnemonic.result) {
					if(0 < qssMnemonic.value.length) {
                        
                        const uniqueMnemonics = qssMnemonic.value.reduce((unique: QssData[], item: QssData) => 
                            unique.some((uniqueItem) => uniqueItem.mnemonic === item.mnemonic) ? unique : [...unique, item], 
                            [] as QssData[]
                        );
                        // console.log(`QssLoadDataList QSS uniqueMnemonics`, uniqueMnemonics)
                        setQssMnemonicList(uniqueMnemonics);
					}
				} else {
                    alert('qss mnemonic load error')
                    setTimeout(() => {
                        navigate('/CreateWallet')
                    }, 1000)
                }
			} catch (error) {
				console.error('Error qss load:', error)
                alert(`Error qSS load. Please Restart miniapp`)
			}
        };

        initializeAssets();
    }, []);

    const handleQssSelMnemonic = async (index: number) => {
        // qssMnemoincList 배열에서 선택한 인덱스의 니모닉 코드 저장
        qSSIndex = index;
        WebApp.showConfirm(t('qss_setting_datalist_screen_message_02'), TgWebAppConfirmCallBack)
    }

    const TgWebAppConfirmCallBack = async (isSuccess: boolean) => {
        if(true !== isSuccess) {
            return
        }

        let index = qSSIndex
        qSSIndex = -1
        try {
            // const selectMnemonic : string = qssMnemoincList[index]
            const selectMnemonic : QssData = qssMnemonicList[index]

            if(null != selectMnemonic.mnemonic && '' !== selectMnemonic.mnemonic) {
                const trimmedSecretPhrase = selectMnemonic.mnemonic.trim()
                const storeMnemonic = trimmedSecretPhrase.split(/\s+/)

                // 복구단계 진행 시작
                if (bip39.validateMnemonic(trimmedSecretPhrase)) {
                    // redux 에 비밀복구코드 배열 임시 저장
                    const jsonMnemonic = JSON.stringify(storeMnemonic)
                    dispatch(checkMnemonic(jsonMnemonic))
                    
                    // 환경설정 qSS 니모닉저장 사용함 설정
                    await setIsUseQss('true')
                    await setIsSavedQssMnemonic('true')

                    // 복구에 사용한 니모닉해시 저장
                    await setLocalMnemonicHash(trimmedSecretPhrase)

                    navigate(`/WalletRecoveryProtection`, { replace: true, state: { } });
                } else {
                    // 환경설정 qSS 니모닉저장 사용안함 설정
                    await setIsUseQss('false')
                    await setIsSavedQssMnemonic('false')

                    // 저장된 니모닉해시 리셋
                    await setLocalMnemonicHash('')

                    // 복구에 사용한 니모닉해시 저장
                    alert('Error validate Mnemonic');
                }
            }

        } catch (error) {
            console.warn(`Error Qss Load Data`, error);
        }
	};

    const styles = {
        container: {
            padding: "60px 5px 24px",
        } as React.CSSProperties,
        inner: {
            display: "flex",
            justifyContent: 'space-between',
            width: "90%"
        } as React.CSSProperties,
        text: {
            fontSize: 16,
            marginBottom: 16,
            textAlign: 'center'
        } as React.CSSProperties,
        button: {
            padding: "24px 12px",
            borderRadius: 10,
            width: '100%',
            position: 'absolute',
            bottom: 60,
            marginBottom: 0,
            justifyContent: 'center'
        } as React.CSSProperties,
        transactionItem: {
            display: "flex",
            alignItems: 'center',
            padding: "13px 15px",
            borderRadius: 10,
            marginBottom: 10,
            border: `1px solid ${theme.line_alternative}`
        } as React.CSSProperties,
        transactionDetails: {
            flex: 1
        } as React.CSSProperties,
        transactionName: {
            fontSize: 15
        } as React.CSSProperties,
        transactionAmountContainer: {
            display: "flex",
            alignItems: 'center'
        } as React.CSSProperties,
    }

    return (
        <div className='container' style={{ ...styles.container, backgroundColor: theme.background_normal }}>
            <div onClick={() => { }} style={styles.inner}>
                <div style={{ flex: 1, justifyContent: 'flex-start', gap: '5px' }}>
                    {qssMnemonicList.map((item, index) => (
                        <div key={index} style={{ ...styles.transactionItem, backgroundColor: theme.card_background_06 }}>
                            <div onClick={() => handleQssSelMnemonic(index)} style={styles.transactionDetails}>
                                <span style={{ ...styles.transactionName, color: theme.label_strong }}>
                                    {item.name}
                                </span>
                            </div>
                            <div style={styles.transactionAmountContainer}>
                            </div>
                        </div>
                    ))}

                    {qssMnemonicList.length === 0 &&  (
                        <div key="1" style={{ ...styles.transactionItem, backgroundColor: theme.card_background_06 }}>
                        <div onClick={() => {}} style={styles.transactionDetails}>
                            <span style={{ ...styles.transactionName, color: theme.label_strong }}>
                                {t('qss_setting_datalist_screen_message_01')}
                            </span>
                        </div>
                        <div style={styles.transactionAmountContainer}>
                        </div>
                    </div>
                    )}

                </div>
            </div>
        </div>
    )
}

export default QssLoadDataList

